import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'maintainOrderKeyValue',
})
export class MaintainOrderKeyValuePipe implements PipeTransform {
  transform(obj: any) {
    //This custom pipe key will maintain the key order of the initial object
    //We needed to built a custom pipe for this, because the Angular KeyValuePipe sorts the array by output key order instead

    const array: any[] = [];

    Object.keys(obj).forEach((key) => {
      array.push({
        key: key,
        value: obj[key],
      });
    });

    return array;
  }
}
